import React, { useRef, useState } from 'react';

import Options from './options';
import Input from './input';
import { Button } from 'components/button';
import { Loading } from 'components/loading';
import { Popup } from 'components/popup';

import { Wrapper } from './Form.styles';

import {
  validateEmail,
  validatePhone,
  validateSubject,
  validateMessage,
} from 'utils/validators';

const COPY = {
  first_name: {
    required: 'Precisamos do teu primeiro nome.',
    invalid: 'Mínimo de 2 caractéres.',
  },
  last_name: {
    required: 'Precisamos do teu último nome.',
    invalid: 'Mínimo de 2 caractéres.',
  },
  email: {
    required: 'Precisamos do teu email.',
    invalid: 'Esse email parece-nos incorrecto.',
  },
  phone: {
    required: 'Precisamos do teu contacto telefónico.',
    invalid:
      'Esse número de telemóvel parece-nos errado. Tenta 9XXXXXXXX ou 003519XXXXXXXX',
  },
  available: {
    required: 'Precisamos de uma hora para contacto.',
    invalid: 'Opção inválida.',
  },
  age: {
    required: 'Precisamos de saber a sua idade.',
    invalid: 'Mínimo de 18',
  },
  city: {
    required: 'Precisamos da tua zona de residência.',
  },
  cv: {
    required: 'Precisamos do teu currículo.',
  },
  name: {
    required: 'Precisamos do nome da empresa.',
    invalid: 'Mínimo de 2 caractéres.',
  },
  dimension: {
    required: 'Precisamos de saber a dimensão da sua empresa.',
  },
  subject: {
    required: 'Precisamos de saber qual o assunto.',
  },
};

const OPTIONS = [
  '09h - 10h',
  '10h - 11h',
  '11h - 12h',
  '12h - 13h',
  '13h - 14h',
  '14h - 15h',
  '15h - 16h',
  '16h - 17h',
  '17h - 18h',
];

const DISTRICTS = [
  'Bragança',
  'Setúbal',
  'Braga',
  'Viana do Castelo',
  'Évora',
  'Vila Real',
  'Açores',
  'Guarda',
  'Viseu',
  'Lisboa',
  'Faro',
  'Santarém',
  'Aveiro',
  'Porto',
  'Coimbra',
  'Madeira',
  'Leiria',
  'Castelo Branco',
  'Beja',
  'Portalegre',
];

const DIMENSION = ['0 - 10', '11 - 25', '25 - 100', '100 - 250', '>250'];

const Form = (props) => {
  //PROPS
  const { recruitment, data: form, consult, partner } = props;
  //PROPS

  // STATES
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState('');
  // STATES

  // REF
  const firstNameInput = useRef();
  const lastNameInput = useRef();
  const emailInput = useRef();
  const phoneInput = useRef();
  const subjectInput = useRef();
  const availableInput = useRef();
  const messageInput = useRef();

  //
  const ageInput = useRef();
  const cvInput = useRef();
  const carInput = useRef();
  const cityInput = useRef();
  //
  const dimensionInput = useRef();
  // REF

  // FUNCTIONS
  const submitForm = () => {
    const contactInput = [
      { label: 'first-name', input: firstNameInput },
      { label: 'last-name', input: lastNameInput },
      { label: 'email', input: emailInput },
      { label: 'phone', input: phoneInput },
      { label: 'subject', input: subjectInput },
      { label: 'message', input: messageInput, noVal: true },
    ];

    const consultInput = [
      { label: 'first-name', input: firstNameInput },
      { label: 'last-name', input: lastNameInput },
      { label: 'email', input: emailInput },
      { label: 'phone', input: phoneInput },
      { label: 'available', input: availableInput },
      { label: 'message', input: messageInput, noVal: true },
    ];

    const partnerInput = [
      { label: 'first-name', input: firstNameInput },
      { label: 'email', input: emailInput },
      { label: 'phone', input: phoneInput },
      { label: 'city', input: cityInput },
      { label: 'dimension', input: dimensionInput },
      { label: 'message', input: messageInput, noVal: true },
    ];

    const recruitmentInput = [
      { label: 'first-name', input: firstNameInput },
      { label: 'last-name', input: lastNameInput },
      { label: 'email', input: emailInput },
      { label: 'phone', input: phoneInput },
      { label: 'age', input: ageInput },
      { label: 'cv', input: cvInput },
      { label: 'city', input: cityInput },
      { label: 'car', input: carInput },
      { label: 'message', input: messageInput, noVal: true },
    ];

    const inputs = consult
      ? consultInput
      : recruitment
      ? recruitmentInput
      : partner
      ? partnerInput
      : contactInput;

    const clearForm = () => {
      inputs.forEach(({ input }) => {
        input.current.clearValue();
      });
    };

    const validate = async () => {
      inputs.forEach(({ input }) => {
        input.current.forceValidation();
      });
    };

    validate().then(async () => {
      const valid = !inputs
        .map(({ input, noVal }) => (noVal ? true : input.current.valid))
        .includes(false);
      if (valid) {
        setLoading(true);
        var formdata = new FormData();

        inputs.forEach(({ label, input }) => {
          formdata.append(
            label,
            label === 'cv'
              ? input.current.ref.current.files[0]
              : input.current.value
          );
        });

        var requestOptions = {
          method: 'POST',
          body: formdata,
          redirect: 'follow',
        };

        fetch(
          `https://wp-nutri.devstudio.com.pt/wp-json/contact-form-7/v1/contact-forms/${form}/feedback`,
          requestOptions
        )
          .then((result) => result.text())
          .then((result) => {
            const data = JSON.parse(result);

            if (data.status === 'mail_sent') {
              clearForm();
            }
            setLoading(false);
            setPopup(data.message);
          })
          .catch((error) => {
            setLoading(false);
            setPopup(
              "Ocorreu um erro, por favor tenta mais tarde ou contacta-nos através do nosso email <a href='mailto:geral@nutri2coach.pt'>geral@nutri2coach.pt</a>"
            );
          });
      }
    });
  };

  const formHTML = () => {
    if (recruitment) {
      return (
        <>
          <div className="form__row">
            <Input
              ref={firstNameInput}
              label="Primeiro Nome"
              type="text"
              required
              slug="first_name"
              validation={(val) => val.trim().length > 2}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.first_name['required']
                  : COPY.first_name['invalid']
              }
              half
            />
            <Input
              ref={lastNameInput}
              label="Último Nome"
              type="text"
              required
              slug="last_name"
              validation={(val) => val.trim().length > 2}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.last_name['required']
                  : COPY.last_name['invalid']
              }
              half
            />
          </div>
          <div className="form__row">
            <Input
              label="Email"
              ref={emailInput}
              required
              type="email"
              slug="email"
              validation={validateEmail}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.email['required']
                  : COPY.email['invalid']
              }
              half
            />
            <Input
              label="Telemóvel"
              slug="phone"
              type="phone"
              ref={phoneInput}
              required
              validation={validatePhone}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.phone['required']
                  : COPY.phone['invalid']
              }
              half
            />
          </div>
          <div className="form__row">
            <Input
              label="Idade"
              slug="age"
              type="number"
              ref={ageInput}
              required
              validation={(val) => val.trim() > 18}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.age['required']
                  : COPY.age['invalid']
              }
              half
            />
            <Options
              ref={carInput}
              label="Carro"
              slug="car"
              half
              required
              errorMessage={(val) => COPY.age['invalid']}
            />
          </div>
          <div className="form__row">
            <Input
              label="Zona de Residência"
              slug="address"
              ref={cityInput}
              type="hour"
              required
              validation={(val) => val.trim().length > 2}
              errorMessage={(val) => COPY.city['required']}
              options={DISTRICTS}
              half
            />
            <Input
              label="CV"
              slug="cv"
              type="file"
              ref={cvInput}
              validation={(val) => val}
              accept=".doc,.docx,.pdf"
              required
              errorMessage={(val) => COPY.cv['required']}
              half
            />
          </div>
          <Input
            label="Mensagem"
            slug="message"
            ref={messageInput}
            type="textarea"
          />
        </>
      );
    } else if (consult) {
      return (
        <>
          <div className="form__row">
            <Input
              ref={firstNameInput}
              label="Primeiro Nome"
              type="text"
              required
              slug="first_name"
              validation={(val) => val.trim().length > 2}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.first_name['required']
                  : COPY.first_name['invalid']
              }
              half
            />
            <Input
              ref={lastNameInput}
              label="Último Nome"
              type="text"
              required
              slug="last_name"
              validation={(val) => val.trim().length > 2}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.last_name['required']
                  : COPY.last_name['invalid']
              }
              half
            />
          </div>
          <div className="form__row">
            <Input
              label="Email"
              slug="email"
              ref={emailInput}
              type="email"
              required
              validation={validateEmail}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.email['required']
                  : COPY.email['invalid']
              }
              half
            />
            <Input
              label="Telemóvel"
              slug="phone"
              ref={phoneInput}
              type="phone"
              required
              validation={validatePhone}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.phone['required']
                  : COPY.phone['invalid']
              }
              half
            />
          </div>
          <div className="form__row">
            <Input
              label="Disponiblidade"
              slug="available"
              ref={availableInput}
              type="hour"
              required
              validation={(val) => val.trim().length > 2}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.available['required']
                  : COPY.available['invalid']
              }
              options={OPTIONS}
              half
            />
          </div>
          <Input
            label="Mensagem"
            slug="message"
            ref={messageInput}
            type="textarea"
          />
        </>
      );
    } else if (partner) {
      return (
        <>
          <div className="form__row">
            <Input
              ref={firstNameInput}
              label="Nome"
              type="text"
              required
              slug="first_name"
              validation={(val) => val.trim().length > 2}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.name['required']
                  : COPY.name['invalid']
              }
              half
            />
            <Input
              label="Email"
              slug="email"
              ref={emailInput}
              type="email"
              required
              validation={validateEmail}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.email['required']
                  : COPY.email['invalid']
              }
              half
            />
          </div>
          <div className="form__row">
            <Input
              label="Telemóvel"
              slug="phone"
              ref={phoneInput}
              type="phone"
              required
              validation={validatePhone}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.phone['required']
                  : COPY.phone['invalid']
              }
              half
            />
            <Input
              label="Zona"
              slug="address"
              ref={cityInput}
              type="hour"
              required
              validation={(val) => val.trim().length > 2}
              errorMessage={(val) => COPY.city['required']}
              options={DISTRICTS}
              half
            />
          </div>
          <div className="form__row">
            <Input
              label="Dimensão"
              slug="dimension"
              ref={dimensionInput}
              type="hour"
              required
              validation={(val) => val.trim().length > 2}
              errorMessage={(val) => COPY.dimension['required']}
              options={DIMENSION}
              half
            />
          </div>
          <div className="form__row"></div>
          <Input
            label="Mensagem"
            slug="message"
            ref={messageInput}
            type="textarea"
          />
        </>
      );
    } else {
      return (
        <>
          <div className="form__row">
            <Input
              ref={firstNameInput}
              label="Primeiro Nome"
              type="text"
              required
              slug="first_name"
              validation={(val) => val.trim().length > 2}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.first_name['required']
                  : COPY.first_name['invalid']
              }
              half
            />
            <Input
              ref={lastNameInput}
              label="Último Nome"
              type="text"
              required
              slug="last_name"
              validation={(val) => val.trim().length > 2}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.last_name['required']
                  : COPY.last_name['invalid']
              }
              half
            />
          </div>
          <div className="form__row">
            <Input
              label="Email"
              slug="email"
              ref={emailInput}
              type="email"
              required
              validation={validateEmail}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.email['required']
                  : COPY.email['invalid']
              }
              half
            />
            <Input
              label="Telemóvel"
              slug="phone"
              ref={phoneInput}
              type="phone"
              required
              validation={validatePhone}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.phone['required']
                  : COPY.phone['invalid']
              }
              half
            />
            <Input
              label="Assunto"
              slug="subject"
              ref={subjectInput}
              required
              type="text"
              validation={validateSubject}
              errorMessage={(val) =>
                val.trim().length === 0
                  ? COPY.text['required']
                  : COPY.text['invalid']
              }
            />
          </div>

          <Input
            label="Mensagem"
            slug="message"
            ref={messageInput}
            required
            type="textarea"
            validation={validateMessage}
            errorMessage={(val) =>
              val.trim().length === 0
                ? COPY.message['required']
                : COPY.message['invalid']
            }
          />
        </>
      );
    }
  };
  // FUNCTIONS

  return (
    <Wrapper>
      {loading && <Loading />}
      <Popup data={popup} setData={setPopup} />
      <form>
        {formHTML()}
        <Button onClick={() => submitForm()} type="button">
          Submeter
        </Button>
      </form>
    </Wrapper>
  );
};

export default Form;
